<template>
  <div style="margin-top: 30px;" >
    <div>
      <h1 class="label-text">
        <div v-if="labelTitleColor1 && labelTitleColor2" class="label-text-title" v-bind:style="{background: 'linear-gradient(2deg, '+labelTitleColor1+', ' + labelTitleColor2 + ')'}">
          {{labelTitle}}
        </div>
        <i>{{name}}</i>
      </h1>
      <span style="float: right; cursor: pointer;" @click="$router.push(`/h/mall/type?labelType=` + type)">查看更多》</span>
    </div>

    <div class="c-box">
      <el-row :gutter="20">
        <el-col :span="6" v-for="index of 8" v-show="load" :key="index">
          <div class="c-item-load">
          </div>
        </el-col>
        <el-col :span="6" v-for="(d, i) in courses" v-show="!load" :key="i">
          <div class="c-item" >
            <div @click="mok(d)">
              <el-image  class="c-item-img" :src="d.icon" :fit="'cover'">
                <div slot="error" class="image-slot" style="background-color: rgb(238, 238, 238);height: 303px;width: 100%">
                </div>
                <div slot="placeholder" class="image-slot" style="background-color: rgb(238, 238, 238);height: 303px;width: 100%">
                </div>
              </el-image>
            </div>

            <div class="c-item-bottom">
              <div class="item-title">
                {{d.trainingName}}
                <span class="name-label" style="color: #ffffff;background-color: #ff4e4e;" v-if="d.isHot == 1">HOT</span>
              </div>
<!--              {{d.entTrainingCount}}-->
              <div class="item-info">共{{d.totalNumber}}节课 · {{d.entTrainingCount && d.entTrainingCount > 10? d.entTrainingCount : 10}}人已学习</div>
              <div class="item-price">
                <span class="ip-btn">课程详情</span>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>
    </div>
  </div>
</template>

<script>

import mallApi from "@/api/mall/mall";

export default {
  name: "labelCourse",
  props: {
    type: {
      type: Number
    },
    labelTitle: {
      type: String
    },
    labelTitleColor1: {
      type: String
    },
    labelTitleColor2: {
      type:String
    },
    name: {
      type: String
    },
    size: {
      type: Number,
      default: () => {
        return 8
      }
    }
  },
  data() {
    return {
      courses:  [],
      load: true
    }
  },
  methods: {

    study(d){
      let token = window.localStorage.getItem('access-token');
      if (token) {
        let userInfo = JSON.parse(localStorage.getItem("userinfo"));
        this.$router.push({path:'/detail',query: {id:d.id}});
        // this.isLogin = true;
        // this.userName = userInfo.name;
      } else {
        this.$router.push('/login')
      }

    },
    mok(d){
      this.$router.push({path:'/detail',query: {id:d.id}});
    },
    loadData() {
      let p = {
        page: 1,
        pageSize: this.size,
        labelType: this.type
      }
      mallApi.search(p).then(res => {
        this.courses = res.data.records;
        if (this.courses && this.courses.length > 0) {
          this.load = false;
        }
      })
    },
  },
  mounted(){
  this.loadData();
  }

}
</script>

<style lang="scss"  scoped>
.c-item-img {
  width: 273px;
  height: 157px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  object-fit: cover;
}

.c-item {
  cursor: pointer;
  width: 273px;
  border-radius: 10px;
  background-color: #ffffff;
  height: 303px;
  margin-top: 20px;
  box-shadow: 2px 3px 3px 0px rgba(190, 206, 218, 0.2);
}

.c-item-load {
  border-radius: 10px;
  background-color: rgb(238, 238, 238);
  height: 303px;
  margin-top: 20px;
}
.c-item-bottom {
  padding-top: 10px;
  padding-bottom: 9px;
  padding-right: 18px;
  padding-left: 18px;
}
.price-rmb {
  color: #F4621F;
  font-size: 12px;
}

.price {
  color: #F4621F;
  font-size: 18px;
}

.item-info {
  color: #a9a9a9;
  font-size: 14px;
  margin-top: 10px;
}

.item-title {
  font-size: 18px;
  height: 52px;
}

.item-price {
  margin-top: 10px;
}

.ip-btn {
  float: right;
  padding: 3px;
  padding-left: 7px;
  padding-right: 7px;
  color: #ffffff;
  border-radius: 13px;
  font-size: 12px;
  background-image: linear-gradient(#ffdc5a, #fcb625);
}

.name-label {
  padding-right: 3px;
  padding-left: 3px;
  border-radius: 4px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  display: inline-block;
  margin-left: 8px;
}

.labelImg {
  height: 43px;
}

.label-text {
  position: relative;
  width: 112px;
  height: 21px;
  i {
    color: rgb(71, 162, 248);
  }
}

.label-text-title {
  background-color: red;
  position: absolute;
  width: 40px;
  height: 20px;
  right: -45px;
  top:-15px;
  font-size: 7px;
  text-align: center;
  line-height: 20px;
  color: #ffffff;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}



.c-box {
  margin-top: 20px;
}

.c-item-img {
  height: 162px;
}
</style>



// WEBPACK FOOTER //
// src/pages/webMall/index/labelCourse.vue